import Swiper, { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

function initialize() {
    new Swiper('.list-news .swiper', {
        modules: [Pagination],

        slidesPerView: 'auto',

        breakpoints: {
            320: {
                slidesOffsetAfter: 32,
                slidesOffsetBefore: 32,
                spaceBetween: 24,
            },
        },
        
        pagination: {
            el: '.list-news .swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    });
}
initialize();
